import React from 'react';
import { TextField, EditButton, ImageField, Responsive, BooleanField, TextInput, Filter } from 'react-admin';
import { List, Datagrid } from '../components/customs';
import MobileGrid from './MobileGrid';
import {isAdmin, isEditor} from '../permissions';
import { ProfileField } from '../helpers/utils';
import TeamReferenceField from '../teams/TeamReferenceField';
import { SearchInput } from '../components/customs/Input';
import { PurgeButton } from '../components/buttons';

const OfficialFilter = (props) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
);

export const OfficialList = ({permissions, ...props}) => (
    <List {...props} filters={<OfficialFilter />} bulkActionButtons={false}>
        <Responsive
            medium={
                <Datagrid>
                    <ProfileField />
                    <TextField source="officialsId" label="Id" />
                    <TeamReferenceField />
                    <TextField source="firstName" />
                    <TextField source="lastName" />
                    <TextField source="birthDate" />
                    <TextField source="nickName" />
                    <TextField source="birthPlace" />
                    <TextField source="type" />
                    <TextField source="country" />
                    <BooleanField source="isImageAvailable" />
                    {(isAdmin(permissions) || isEditor(permissions)) && <PurgeButton />}
                    {(isAdmin(permissions) || isEditor(permissions)) && <EditButton />}
                </Datagrid>
            }
        />
    </List>
);

